import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";

import { allSharedComponents } from "../../../../../shared";
import { centerInstructorsActions } from "../../../../../redux/actions";
import {
  Directions,
  fieldLengthConstants,
  globalConstants,
  translationConstants,
} from "../../../../../constants";
import { sportNames } from "../../../../AdminPortal/Views/Spots/utilities";
import ShowUserLevels from "../../../../../shared/components/ShowUserLevels/ShowUserLevels";

const { SpinnerContainer } = allSharedComponents;

const AddInstructorModal = (props) => {
  const { Mandatory_Character } = globalConstants;

  const dispatch = useDispatch();
  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );

  const userData = useSelector(
    (state) => state.centerInstructors?.instrctorDetails
  );
  const centerId = useSelector(
    (state) => state.LoginReducer.UserData.user.centerId
  );

  const {
    setValue,
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const { t } = useTranslation();

  const [searchInput, setSearchInput] = useState("");

  const onSubmit = () => {
    dispatch(
      centerInstructorsActions.addCenterInstructor(
        centerId,
        userData?.id,
        props.gridState,
        props.setShow
      )
    );
  };

  const getSportNamesAndLevels = (sportLevels) => {
    // Map sportLevels to their corresponding names and levels
    const sportNamesAndLevels = sportLevels?.map(({ sportId, levelId }) => {
      const sportName = sportNames[sportId];
      const level = `Level ${levelId}`;
      return `${sportName} ${level}`;
    });

    //Join the names and levels with commas
    return sportNamesAndLevels.join(", ");
  };

  useEffect(() => {
    //Set initial form values from selected spot
    if (userData) {
      setValue("firstName", userData?.englishFirstName);
      setValue("firstNameArabic", userData?.arabicFirstName);
      setValue("lastName", userData?.englishLastName);
      setValue("lastNameArabic", userData?.arabicLastName);
      setValue("email", userData?.email);
      if (userData?.sportLevels) {
        const sportAndLevelsString = getSportNamesAndLevels(
          userData?.sportLevels
        );
        setValue("instructorLevel", sportAndLevelsString);
      }
    }

    // eslint-disable-next-line
  }, [userData]);

  const handleSearch = (e) => {
    e.preventDefault();
    setValue("firstName", "");
    setValue("firstNameArabic", "");
    setValue("lastName", "");
    setValue("lastNameArabic", "");
    setValue("email", "");
    dispatch(
      centerInstructorsActions.getInstructorByEmail({ email: searchInput })
    );
  };

  //Handle search input change
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchInput(value);
  };

  return (
    <div>
      <Form
        noValidate
        className="ViewUserContent p-5 mx-4"
        onSubmit={handleSearch}
      >
        <div className="ViewHeader">
          <p className="viewUserPara">
            {props?.totalElements > 0
              ? t(translationConstants.ADD_INSTRUCTOR)
              : t(translationConstants.INVITE_HEAD_INSTRUCTOR)}
          </p>
        </div>
        <p className="horizentalLine" />

        <div className="inputRow">
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.SEARCH_INSTRUCTOR)}:
            </Form.Label>
            <div className="searchInputDivBGWhite d-flex justify-content-center bg-white align-items-center">
              <div className=" d-flex bg-white w-100 p-0 pr-10 borderRadius-100">
                <input
                  type="text"
                  className="bg-white px-4 searchInputSecondary nonStyleRoundedField"
                  placeholder={t(translationConstants.Search)}
                  onChange={handleSearchChange}
                />
              </div>
              <div className="px-3 pt-1 cursor-pointer">
                <svg
                  onClick={handleSearch}
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.15336 7.34119L11.2153 10.4032C11.323 10.5109 11.3834 10.6569 11.3833 10.8092C11.3833 10.9614 11.3227 11.1074 11.215 11.215C11.1073 11.3227 10.9613 11.3831 10.809 11.383C10.6568 11.383 10.5108 11.3225 10.4032 11.2148L7.34119 8.15279C6.42585 8.86175 5.2748 9.19538 4.12221 9.0858C2.96961 8.97623 1.90205 8.43168 1.1367 7.56293C0.371351 6.69419 -0.0342993 5.56651 0.00227447 4.40929C0.0388482 3.25208 0.514898 2.15226 1.33358 1.33358C2.15226 0.514898 3.25208 0.0388482 4.40929 0.00227447C5.56651 -0.0342993 6.69419 0.37135 7.56294 1.1367C8.43168 1.90205 8.97623 2.96961 9.08581 4.12221C9.19538 5.2748 8.86232 6.42585 8.15336 7.34119ZM4.55354 7.96781C5.45922 7.96781 6.32779 7.60804 6.9682 6.96763C7.60861 6.32722 7.96839 5.45865 7.96839 4.55297C7.96839 3.6473 7.60861 2.77872 6.9682 2.13832C6.32779 1.49791 5.45922 1.13813 4.55354 1.13813C3.64787 1.13813 2.77929 1.49791 2.13889 2.13832C1.49848 2.77872 1.1387 3.6473 1.1387 4.55297C1.1387 5.45865 1.49848 6.32722 2.13889 6.96763C2.77929 7.60804 3.64787 7.96781 4.55354 7.96781Z"
                    fill="#2C7465"
                  />
                </svg>
              </div>
            </div>
          </Form.Group>
        </div>

        <div className="inputRow">
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.firstName) + ":" + Mandatory_Character}:
            </Form.Label>
            <Form.Control
              {...register("firstName", {})}
              id="firstName"
              type="text"
              maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
              className="bg-gray"
              disabled={true}
            />
          </Form.Group>

          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.lastName) + ":" + Mandatory_Character}:
            </Form.Label>
            <Form.Control
              {...register("lastName", {})}
              id="lastName"
              className="bg-gray"
              type="text"
              maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
              disabled={true}
            />
          </Form.Group>
        </div>

        <div className="inputRow">
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.firstNameArabic)}:{" "}
              <span>{t(translationConstants.optional)}</span>{" "}
            </Form.Label>
            <Form.Control
              {...register("firstNameArabic", {})}
              id="firstNameArabic"
              className="bg-gray"
              type="text"
              maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
              style={{ direction: Directions.rtl }}
              disabled={true}
            />
          </Form.Group>

          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.lastNameArabic)}:{" "}
              <span>{t(translationConstants.optional)}</span>
            </Form.Label>
            <Form.Control
              {...register("lastNameArabic", {})}
              id="lastNameArabic"
              type="text"
              maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
              className="bg-gray"
              style={{ direction: Directions.rtl }}
              disabled={true}
            />
          </Form.Group>
        </div>

        <div className="inputRow">
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.email) + ":" + Mandatory_Character}
            </Form.Label>
            <Form.Control
              {...register("email", {})}
              id="email"
              className="bg-gray"
              type="email"
              maxLength={fieldLengthConstants.EMAIL_FIELD_LENGTH}
              disabled={true}
            />
          </Form.Group>
        </div>

        {userData?.sportLevels && (
          <div className="row mt-3">
            <label className="Form-labels form-label">
              {t(translationConstants.INSTRUCTOR_LEVEL)}:
            </label>
            <ShowUserLevels userLevels={userData?.sportLevels} />
          </div>
        )}

        <div className="row d-flex justify-content-center mt-4">
          <div className="col-lg-4">
            {userData == null ? (
              <Button
                className="UpdateUserView-button w-100"
                type="button"
                disabled={true}
                onClick={handleSubmit(onSubmit)}
              >
                {t(translationConstants.ADD_INSTRUCTOR)}
              </Button>
            ) : (
              <Button
                className="UpdateUserView-button w-100"
                type="button"
                onClick={handleSubmit(onSubmit)}
              >
                {t(translationConstants.ADD_INSTRUCTOR)}
              </Button>
            )}
            <Button className="d-none" type="submit"></Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default AddInstructorModal;
